import React, {Fragment, useEffect, useState} from "react";
import {EXTERNAL_icons} from "root/s360components/constants/S360_constants";
import AppLink from "root/s360components/AppLink";
import {useAdminUsersDashboardContext} from "root/s360components/AdminUsersDashboardContext";
import {getEschoolsUrlForSchool} from "root/DataFunctions/HelperDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import SpinnerDiv from "root/gdpr/ui/SpinnerDiv";

/**
 * @uses useAdminUsersDashboardContext
 * @returns {JSX.Element}
 * @constructor
 */
const ESchoolsDashboardLink = ({school_id}) =>
{

    const [showSpinner, setShowSpinner] = useState(false);

    const onClickNavigateESchool = (school_id) =>
    {

        setShowSpinner(true);

        getEschoolsUrlForSchool(school_id)
            .then((response) =>
            {
                const data = getDataFromResponse(response);

                if (data.length !== 0)
                {
                    const url = data[0].url;

                    window.open(url);

                    setShowSpinner(false);
                }
            })
    }

    return (
        <Fragment>
            {!showSpinner && <div onClick={() => onClickNavigateESchool(school_id)}><AppLink target='_blank' title='ESchools'
                     imageSrc={EXTERNAL_icons.ESCHOOLS}/></div>}
            {showSpinner && <SpinnerDiv />}
        </Fragment>
    )
}

export default ESchoolsDashboardLink;